interface DocumentWithFullscreen extends HTMLDocument {
    mozFullScreenElement?: Element;
    msFullscreenElement?: Element;
    webkitFullscreenElement?: Element;
    msExitFullscreen?: () => void;
    mozCancelFullScreen?: () => void;
    webkitExitFullscreen?: () => void;
    webkitFullscreenEnabled?: boolean;
}

/** false sur iPhone (Safari n'autorise le plein écran que pour les vidéos) et dans
 * certains navigateurs intégrés d'applis : le bouton n'y ferait rien. */
export function isFullscreenSupported(): boolean {
    const doc = document as DocumentWithFullscreen;
    return !!(doc.fullscreenEnabled || doc.webkitFullscreenEnabled);
}

export function isFullscreen(): boolean {
    const doc = document as DocumentWithFullscreen;
    return !!(
        doc.fullscreenElement ||
        doc.mozFullScreenElement ||
        doc.webkitFullscreenElement ||
        doc.msFullscreenElement
    );
}

interface DocumentElementWithFullscreen extends HTMLElement {
    msRequestFullscreen?: () => void;
    mozRequestFullScreen?: () => void;
    webkitRequestFullscreen?: () => void;
}

/* MANAGING FULLSCREEN */
export function openFullscreen(element: DocumentElementWithFullscreen) {
    if (element.requestFullscreen) {
        // Rejette quand le navigateur refuse (WebView d'appli, geste non reconnu) :
        // le plein écran est un confort, l'échec ne doit pas remonter en erreur.
        Promise.resolve(element.requestFullscreen()).catch(() => {});
    } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
    } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
    }
}

export function closeFullscreen(doc: DocumentWithFullscreen) {
    if (doc.exitFullscreen) {
        Promise.resolve(doc.exitFullscreen()).catch(() => {});
    } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
    } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
    } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
    }
}

export function toggleFullscreen(elem = document.documentElement): void {
    if (!isFullscreen()) {
        openFullscreen(elem);
    } else {
        closeFullscreen(document);
    }
}
